export enum TwoFactorAuthStatus {
  None = 0,
  Google = 1,
  Email = 2,
  Disabled = 3,
}
